const KioskActionButtonStyle = `
  &:disabled {
    background: red;
  }
`;

export default KioskActionButtonStyle;
